<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Sync Leave Data</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2" md="2">
                        <p><v-icon color="error">*</v-icon><b>Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="calendar_year"
                            :items="calendar_year_list" item-text="name" item-value="id" label="Year"
                            @change="getSalaryMonths()" outlined persistent-hint hint="Please Select Year" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="this.salary_month_list.length > 0">
                        <p><v-icon color="error">*</v-icon><b>Salary Month</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="salary_month"
                            :items="salary_month_list" item-text="sal_mon" item-value="id" label="Month" outlined
                            persistent-hint hint="Please Select Month" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" v-if="this.show_emp_list == true">
                        <p><v-icon color="error">*</v-icon><b>Employee </b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" multiple outlined persistent-hint
                            hint="Please Select Employee" />
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="this.salary_month && this.employee">
                    <v-btn color="warning" @click="syncLeaveData()" :loading="loader">Sync</v-btn>
                </v-row>
            </v-card>

            <!-- <v-card class="box" v-if="query_list.length > 0">
     <v-data-table  :headers="headers" :items="query_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Queries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card> -->
        </v-container>
    </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
      loader:false,
        snackbar_msg: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
      color: "",
      snackbar: false,
      overlay: false,
      calendar_year_list:[],calendar_year:"",salary_month_list:[],salary_month:"",employee_list:[],employee:"",show_emp_list:false,
      headers:[
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      ],
  }),
   methods: {
    syncLeaveData(){
         const data = {
            year: this.calendar_year,
            salary_month: this.salary_month,
            employee_list: this.employee,
        };
        this.overlay = true;
        this.loader = true;
        axios
            .post("/EmployeeBiometric/syncLeaveData", data)
            .then((res) => {
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", "Synced Successfully...");
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
                this.loader = false;
            })
            .catch((error) => {
                this.onerror(error);
                this.overlay = false;
                this.loader = false;
            })
            .finally(() => {
                this.overlay = false;
                this.loader = false;
            });
    },
      getSalaryMonths() {
        const data = {
            year: this.calendar_year,
        };
        this.overlay = true;
        axios
            .post("/Payroll/getSalaryMonth", data)
            .then((res) => {
                if (res.data.flag == "YES") {
                     this.salary_month_list = res.data.sal_month_list;
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
            })
            .catch((error) => {
                this.onerror(error);
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
                this.show_emp_list=true
            });
    },
     onLoad() {
        axios
            .post("EmployeeBiometric/getPayrollInfo")
            .then((res) => {
                if (res.data.flag == "YES") {
                    this.calendar_year_list = res.data.calendar_year_list;
                    this.employee_list = res.data.instructor_list;
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
            });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>